import React from 'react';
import classNames from 'classnames';
import PageHeaderCount from './page_header_count';

interface Props {
  children: React.ReactNode;
  top?: boolean;
}

export default function PageHeaderActions({ children, top = false }: Props) {
  const childArray = React.Children.toArray(children);
  const countChildren = childArray.filter(
    child => React.isValidElement(child) && child.type === PageHeaderCount
  );
  const actionChildren = childArray.filter(
    child => !(React.isValidElement(child) && child.type === PageHeaderCount)
  );

  return (
    <div className={classNames('d-flex align-items-center gap-3', { 'align-self-start': top })}>
      {countChildren.length > 0 && countChildren}
      {actionChildren.length > 0 && (
        <div className="d-flex align-items-center gap-2">{actionChildren}</div>
      )}
    </div>
  );
}
